module.exports = {
  储值中心: '儲值中心',
  角色信息: '角色信息',
  '角色：': '角色：',
  '区服：': '區服：',
  '游戏：': '遊戲：',
  '商品：': '商品：',
  支付方式: '儲值方式',
  '结算：': '結算：',
  '订单金额：': '訂單金額：',
  '支付金额：': '儲值金額：',
  确认支付: '確認儲值',
  请选择支付方式: '請選擇儲值方式',
  '注意：支付金额请以实际支付时为准': '註意：儲值金額請以實際儲值時為準',
  '订单号：': '訂單號：',
  '时间：': '時間：',
  '支付方式：': '儲值方式：',
  '钱包：': '錢包：',
  '订单状态：': '訂單狀態：',
  '说明：': '說明：',
  '如有疑问，请联系客服cshw@ijunhai.com':
    '如有疑問，請聯系客服cshw@ijunhai.com',
  支付失败: '儲值失敗',
  购买中: '購買中',
  支付成功: '儲值成功',
  购买成功: '購買成功',
  购买失败: '購買失敗',
  unknow: 'unknow',
  全部: '全部',
  下拉更新: '下拉更新',
  松开更新: '松開更新',
  更新中: '更新中',
  '加载中……': '加載中……',
  暂无数据: '暫無數據',
  支付完成: '儲值完成',
  '请在游戏内查收道具。如需帮助，可以联系我们的客服':
    '請在遊戲內查收道具。如需幫助，可以聯系我們的客服',
  结束充值: '結束充值',
  '没有记录哦~': '沒有記錄哦~',
  '卡号：': '卡號：',
  '密码：': '密碼：',
  储值记录: '儲值記錄',
  '可用余额：': '可用餘額：',
  T币: 'T幣',
  账号信息: '賬號信息',
  '用户ID：': '用戶ID：',
  账号注销: '帳號註銷',
  修改密码: '修改密碼',
  旧密码: '舊密碼',
  '新密码（6-20位字符）': '新密碼（6-20位字符）',
  为了您的账户安全: '为了您的賬戶安全',
  '请联系客服人员进行再次确认：cshw@iijunhai.com':
    '請聯繫客服人員再次確認：cshw@ijunhai.com',
  确定: '確定',
  请选择: '請選擇',
  返回首页: '返回首頁',
  '如需帮助，请联系我们的邮箱：': '如需幫助，請聯繫我們的郵箱：',
  继续充值: '繼續儲值',
  '选择区服/角色': '選擇伺服器/角色',
  确认付款: '確認付款',
  充值商品: '儲值商品',
  商品赠送: '商品贈送',
  实际支付: '實際支付',
  立即充值: '立即儲值',
  取消支付: '取消支付',
  支付确认: '支付確認',
  '请确认是否支付完成？': '請確認是否支付完成？',
  继续支付: '繼續支付',
  '使用以下方式完成储值，额外获赠': '使用以下方式完成储值，額外獲贈',
  元宝: '元寶',
  你已完成储值: '你已完成储值',
  '储值失败，请重试': '储值失敗，請重試',
  选择支付方式: '選擇支付方式',
  '完成储值，额外获赠': '完成储值，額外獲贈',
  '余额不足，剩余': '餘額不足，剩餘',
  MyCard点卡: 'Mycard點卡',
  MyCard短代: 'Mycard短代',
  MyCard会员充值: 'Mycard會員充值',
  Coda支付: 'Coda-點卡',
  Mycard银行转账: 'Mycard銀行轉賬',
  立即支付: '立即支付',
  返回游戏: '返回遊戲',
  mol: 'Razer',
  用户协议: '用戶協議',
  隐私协议: '隱私協議',
  游戏账号删除协议: '遊戲帳號删除協定',
  账号删除进程: '帳號删除行程',
  游戏账号删除条件: '遊戲賬號刪除條件',
  '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。': '我們為您做出如下特別說明：在删除本遊戲的遊戲帳號後，除法律法規或本協定另有規定外，您在該遊戲帳號下的個人資訊將進行删除或匿名化處理，且此前已關聯該遊戲帳號的相關產品與服務將不再關聯。 該遊戲帳號一旦删除完成，將無法恢復，您無法再檢索、繼續使用、訪問和召回，也無權要求我們找回個人資訊，請您謹慎操作。 前述個人資訊包括但不限於頭像、昵稱、會員權益、等級/經驗值等與遊戲角色成長陞級相關的所有數據、虛擬貨幣、虛擬道具等虛擬物品、聊天記錄等內容。',
  '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。': '1、帳號必須事先綁定郵箱。 删除帳號需要用郵箱進行驗證，確保是本人操作。',
  '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。': '2、遊戲收益已結清或得到妥善處理：包括但不局限於遊戲代幣、道具、會員權益等收益。 請您妥善處理，若未處理，視為您自願放弃該等收益。',
  '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。': '3、帳號無任何糾紛：包括投訴舉報、被投訴舉報、仲裁、訴訟等糾紛。',
  '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。': '親愛的玩家，在您正式開始下一步有關本遊戲的删除遊戲帳號流程前，請您務必先行仔細閱讀、充分理解並同意《删除遊戲賬號協議》（以下統稱“本協定”）。 您按照遊戲內提示的删除遊戲帳號之操作流程進行删除帳號申請或開始删除帳號流程的，或者您勾選本删除遊戲帳號協定並開始下一步操作的，均視為您已經同意和遵守本協定全部內容。',
  有关删除游戏账号的其它详细规则及注意事项请点击查看: '有關删除遊戲帳號的其它詳細規則及注意事項請點擊查看',
  删除游戏账号协议: '删除遊戲帳號協定',
  '将删除的游戏账号：': '將删除的遊戲帳號',
  游戏账号: '遊戲帳號',
  游戏ID: '遊戲ID',
  失败原因: '失敗原因',
  '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用': '親愛的用戶，為確保您的帳號安全，請提供您帳號綁定的手機號驗證碼以供帳號删除校驗，該驗證碼僅用於本次驗證使用',
  邮箱: '郵箱',
  验证码: '驗證碼',
  请输入验证码: '輸入驗證碼',
  获取验证码: '獲取',
  请描述你除账号的原因: '請描述你除帳號的原因',
  '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：': '為防止誤操作，請您再次確認是否删除遊戲帳號並確認删除後的影響，該影響包括但不限於（具體詳見:',
  '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。': '1.該帳號一旦删除成功，您將無法登入、使用該遊戲帳號，且無法回復。 除法律法規和《删除遊戲賬號協議》另有約定外，您在該遊戲帳號下的個人資訊將進行删除或匿名化處理，且此前已關聯該遊戲帳號的相關產品與服務將不再關聯。 該遊戲帳號一旦删除完成，將無法恢復，您無法再檢索、繼續使用、訪問和召回，也無權要求我們找回個人資訊，請您謹慎操作。',
  '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。': '2.您確認知悉，删除遊戲帳號的，該帳號在本遊戲使用期間已產生及未來可能產生是所有遊戲收益或權益將會被全部删除/清除。 據此，也特別提示您，在您開始删除本遊戲帳號前請您妥善處理您的遊戲收益或權益。 否則，帳號删除後，我們有權利對該帳號下的全部收益或權益做删除/清除處理，囙此產生的後果由您自行承擔，前遊戲收益或權益包括但不限於帳號內剩餘的所有遊戲虛擬貨幣、虛擬道具及其它虛擬物品及增值服務。',
  您的游戏角色将于: '您的遊戲角色將於',
  '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。': '完成删除。 請注意，該帳號删除有15日的冷靜期（帳號鎖定期）。 除法律法規規定和協議約定情形外我們將在冷靜期滿後完成删除，删除或匿名化處理您的個人資訊。',
  '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。': '在此期間，請您不要登入和使用該帳號，以確保删除的順利完成，否則視為您撤銷删除申請。',
  确认删除游戏账号: '確認删除',
  放弃删除: '放弃删除',
  下一步: '下一步',
  这是个多余的账号: '這是個多餘的帳號',
  弃游不想再玩: '弃遊不想再玩',
  需要解绑邮箱: '需要解綁郵箱',
  需要换绑实名认证信息: '需要換綁實名認證資訊',
  其他: '其他',
  我已详细阅读并满足删除账号条件: '我已詳細閱讀並滿足删除帳號條件',
  确认删除的游戏账号: '確認删除的遊戲帳號',
  我已详细阅读并同意: '我已詳細閱讀並同意',
  验证本账号绑定的邮箱: '驗證本帳號綁定的郵箱',
  选择删除的原因: '選擇删除的原因',
  再次确认是否删除游戏账号并确认删除后的影响: '再次確認是否删除遊戲帳號並確認删除後的影響',
  删除游戏账号申请提交成功: '删除遊戲帳號申請提交成功',
  完成: '完成',
  验证码发送成功: '驗證碼已發送，請注意查收',
  '请先勾选【我已仔细阅读并满足账号删除条件】': '請先勾選【我已仔細閱讀並滿足帳號删除條件】',
  '请先勾选【我已阅读并同意': '請先勾選【我已閱讀並同意',
  账号删除申请失败: '帳號删除申請失敗',
  验证成功: '驗證成功',
  请选择删除原因: '請選擇删除原因',
  用户的游戏账号未绑定邮箱: '用戶的遊戲賬號未綁定郵箱',
  '请先勾选【我已阅读并同意《游戏账号删除协议》】': '請先勾選【我已閱讀並同意《遊戲賬號删除協議》】',
};



// WEBPACK FOOTER //
// ./src/common/lang/zh-tw.js